import { Box } from '@mui/material';

type SummaryItemProps = {
  title: string
  value: string
  isBold?: boolean
  displayVAT?: boolean
  VAT?: boolean
}

const SummaryItem = ({ title, value, displayVAT, VAT }: SummaryItemProps) => (
  <Box
    component="div"
    sx={(theme) => ({
      padding: '10px',
      backgroundColor: theme.palette.brand.main,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start', // Align items to the top
      textWrap: 'nowrap',
      verticalAlign: 'top',
      alignItems: 'center',
    })}
  >
    <Box
      component="p"
      sx={(theme) => ({
        textTransform: 'uppercase',
        fontSize: '14px',
        fontWeight: 'bold',
        color: theme.palette.brand.contrastText ?? '#fff',
      })}
    >
      {title}
    </Box>
    <Box
      component="p"
      sx={{
        textTransform: 'uppercase',
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#ffffff',
      }}
    >
      {value}
    </Box>
    <Box
      component="p"
      sx={{
        marginTop: '-10px',
        textTransform: 'uppercase',
        fontSize: '11px',
        color: '#ffffff',
      }}
    >
      {displayVAT ? (VAT ? 'Incl VAT' : 'Excl VAT') : ''}
    </Box>
  </Box>
)

export default SummaryItem
